(function(){

  /* ══════════════════════════════════════
     APPLE-STYLE SLIDESHOW
  ══════════════════════════════════════ */
  var slideshow   = document.getElementById('jcbSlideshow');
  var slides      = slideshow ? slideshow.querySelectorAll('.jcb-slide') : [];
  var dots        = slideshow ? slideshow.querySelectorAll('.jcb-dot') : [];
  var progressBar = document.getElementById('jcbProgressBar');
  var playPauseBtn= document.getElementById('jcbPlayPause');

  var current     = 0;
  var total       = slides.length;
  var interval    = 5500;   // ms per slide
  var timer       = null;
  var isPlaying   = true;
  var isEnded     = false;

  function setEndedState() {
    isEnded = true;
    isPlaying = false;
    clearInterval(timer);
    timer = null;
    if (slideshow) {
      slideshow.classList.remove('is-paused');
      slideshow.classList.add('is-ended');
    }
    resetDotFills();
    // Fill the last dot fully to show completion
    if (dots[current]) {
      dots[current].style.setProperty('--dot-fill', '100%');
    }
    if (playPauseBtn) {
      playPauseBtn.setAttribute('aria-label', 'Restart slideshow');
    }
  }

  function clearEndedState() {
    isEnded = false;
    if (slideshow) slideshow.classList.remove('is-ended');
  }

  function goToSlide(n) {
    if (n === current || !total) return;
    // Deactivate current
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    // Activate new
    current = ((n % total) + total) % total;
    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
    // Reset progress
    resetProgress();
  }

  function nextSlide() {
    // If we're on the last slide, end the slideshow
    if (current === total - 1) {
      setEndedState();
      return;
    }
    goToSlide(current + 1);
  }

  function restartSlideshow() {
    clearEndedState();
    goToSlide(0);
    startAutoplay();
  }

  function resetDotFills() {
    dots.forEach(function(d) {
      d.classList.remove('is-filling');
      d.style.setProperty('--dot-fill', '0%');
    });
  }

  function resetProgress() {
    resetDotFills();
    var dot = dots[current];
    if (!dot) return;
    // Force reflow to restart
    dot.offsetWidth;
    if (isPlaying) {
      dot.classList.add('is-filling');
      dot.style.setProperty('--dot-duration', interval + 'ms');
      dot.style.setProperty('--dot-fill', '100%');
    }
  }

  function startAutoplay() {
    stopAutoplay();
    isPlaying = true;
    clearEndedState();
    if (slideshow) slideshow.classList.remove('is-paused');
    if (playPauseBtn) playPauseBtn.setAttribute('aria-label', 'Pause slideshow');
    resetProgress();
    slideStartTime = Date.now();
    timer = setInterval(function() {
      slideStartTime = Date.now();
      nextSlide();
    }, interval);
  }

  function stopAutoplay() {
    isPlaying = false;
    if (slideshow) slideshow.classList.add('is-paused');
    if (playPauseBtn) playPauseBtn.setAttribute('aria-label', 'Play slideshow');
    clearInterval(timer);
    timer = null;
    resetDotFills();
  }

  function togglePlayPause() {
    if (isEnded) {
      restartSlideshow();
    } else if (isPlaying) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  }

  // Dot click handlers
  if (dots.length) {
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(dot.dataset.dot, 10);
        if (isEnded) clearEndedState();
        goToSlide(idx);
        if (isPlaying) {
          startAutoplay(); // restart timer
        } else if (isEnded) {
          // If was ended and user clicks a dot, start playing
          startAutoplay();
        }
      });
    });
  }

  // Play/pause button
  if (playPauseBtn) {
    playPauseBtn.addEventListener('click', togglePlayPause);
  }

  // Pause on hover, resume on leave (desktop feel)
  // Track remaining time so progress bar continues smoothly
  var hoverPauseTime = 0;
  var slideStartTime = 0;

  if (slideshow) {
    slideshow.addEventListener('mouseenter', function() {
      if (isPlaying && timer) {
        hoverPauseTime = Date.now();
        clearInterval(timer);
        timer = null;
        // Pause the dot fill
        var dot = dots[current];
        if (dot) {
          var elapsed = hoverPauseTime - slideStartTime;
          var pct = Math.min((elapsed / interval) * 100, 100);
          dot.classList.remove('is-filling');
          dot.style.setProperty('--dot-fill', pct + '%');
        }
      }
    });
    slideshow.addEventListener('mouseleave', function() {
      if (isPlaying && !timer) {
        var elapsed = hoverPauseTime - slideStartTime;
        var remaining = Math.max(interval - elapsed, 200);
        // Resume dot fill from where it paused
        var dot = dots[current];
        if (dot) {
          dot.offsetWidth;
          dot.classList.add('is-filling');
          dot.style.setProperty('--dot-duration', remaining + 'ms');
          dot.style.setProperty('--dot-fill', '100%');
        }
        timer = setTimeout(function() {
          nextSlide();
          if (isPlaying) {
            slideStartTime = Date.now();
            timer = setInterval(function() {
              slideStartTime = Date.now();
              nextSlide();
            }, interval);
          }
        }, remaining);
      }
    });
  }

  // Scroll reveal for the slideshow
  if (slideshow && 'IntersectionObserver' in window) {
    var slideshowObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          startAutoplay();
          slideshowObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    slideshowObs.observe(slideshow);
  } else if (slideshow) {
    slideshow.classList.add('is-visible');
    startAutoplay();
  }

  // Keyboard nav
  document.addEventListener('keydown', function(e) {
    if (!slideshow) return;
    if (e.key === 'ArrowRight') {
      if (isEnded) { restartSlideshow(); return; }
      nextSlide();
      if (isPlaying) startAutoplay();
    }
    if (e.key === 'ArrowLeft') {
      if (isEnded) clearEndedState();
      goToSlide(current - 1);
      if (isPlaying) startAutoplay();
    }
    if (e.key === ' ' && document.activeElement === playPauseBtn) {
      e.preventDefault();
      togglePlayPause();
    }
  });


  /* ══════════════════════════════════════
     STEP NAVIGATION (unchanged logic)
  ══════════════════════════════════════ */
  var steps = document.querySelectorAll('.jcb-step');
  var panels = document.querySelectorAll('.jcb-panel');
  var currentStep = 0;

  function goToStep(n) {
    if (n < 0 || n >= steps.length) return;
    if (n === 2) updateSummary();
    currentStep = n;
    steps.forEach(function(s, i) {
      s.classList.remove('is-active');
      if (i <= n) s.classList.add('is-active');
    });
    panels.forEach(function(p) { p.classList.remove('is-active'); });
    panels[n].classList.add('is-active');
    if (n > 0) {
      var proc = document.querySelector('.jcb-process');
      if (proc) proc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  steps.forEach(function(s, i) {
    s.addEventListener('click', function() { goToStep(i); });
  });

  document.querySelectorAll('[data-jcb-next]').forEach(function(btn) {
    btn.addEventListener('click', function() { goToStep(currentStep + 1); });
  });
  document.querySelectorAll('[data-jcb-back]').forEach(function(btn) {
    btn.addEventListener('click', function() { goToStep(currentStep - 1); });
  });
  document.querySelectorAll('[data-jcb-goto]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      goToStep(parseInt(btn.dataset.jcbGoto));
    });
  });


  /* ══════════════════════════════════════
     STYLE SELECTION
  ══════════════════════════════════════ */
  var styleBtns = document.querySelectorAll('.jcb-style-btn');
  var selectedStyle = '';

  styleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      styleBtns.forEach(function(b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selectedStyle = btn.dataset.style;
      var el = document.getElementById('jcbSummaryStyle');
      if (el) el.textContent = selectedStyle;
    });
  });


  /* ══════════════════════════════════════
     CONTACT SUMMARY
  ══════════════════════════════════════ */
  function updateSummary() {
    var fields = document.querySelectorAll('.jcb-measure__input');
    var summaryMeas = document.getElementById('jcbSummaryMeasure');
    if (!summaryMeas) return;
    var parts = [];
    fields.forEach(function(f) {
      if (f.value.trim()) {
        parts.push(f.dataset.label + ': ' + f.value.trim());
      }
    });
    summaryMeas.textContent = parts.length ? parts.join(' | ') : 'Not provided';
  }


  /* ══════════════════════════════════════
     PREPOPULATE CONTACT MESSAGE
  ══════════════════════════════════════ */
  var submitBtn = document.getElementById('jcbSubmit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      var msgEl = document.getElementById('jcbMessage');
      if (!msgEl) return;
      var prefix = '';
      if (selectedStyle) prefix += 'Style: ' + selectedStyle + '\n';
      var fields = document.querySelectorAll('.jcb-measure__input');
      fields.forEach(function(f) {
        if (f.value.trim()) prefix += f.dataset.label + ': ' + f.value.trim() + '\n';
      });
      if (prefix && msgEl.value.indexOf('Style:') === -1) {
        msgEl.value = prefix + '\n' + msgEl.value;
      }
    });
  }

  // Init steps
  if (steps.length && panels.length) goToStep(0);

})();
